// extracted by mini-css-extract-plugin
module.exports = {"main-wrapper":"Credit_main-wrapper__2sPXO","btn-back":"Credit_btn-back__2UMDi"};